import { useCallback, useContext, useEffect, useRef } from "react";
import { store } from "../components/Store";
import { AVAILABLE_LANGUAGES_ARRAY } from "../config/constants";
import { useHistory, useLocation } from "react-router-dom";
import { useIsEnglishUrl } from "./is-english-url";

/**
 * Hook para manejar la selección de lenguaje, el idioma no se puede cambiar desde otro lugar, usar este hook.
 */
export const useLanguageSelection = () => {
	const { dispatch } = useContext(store);
	const location = useLocation();
	const history = useHistory();
	const pathnname = location.pathname;
	const isEngUrl = useIsEnglishUrl();

	useEffect(() => {
		if (isEngUrl) {
			updateStateLanguage({ lang: "en" });
		} else {
			updateStateLanguage({ lang: getLanguageFromLocalStorage() });
		}
	}, [isEngUrl]);

	const getLanguageFromLocalStorage = () => localStorage.getItem("language");

	const updateStateLanguage = ({ lang }) => {
		let finalLang = lang || "es";
		if (!AVAILABLE_LANGUAGES_ARRAY.includes(lang)) {
			finalLang = "es";
		}
		dispatch({
			type: "CHANGE_VALUE",
			property: "language",
			value: finalLang,
		});
	};

	const updateLocalStorageLanguage = ({ lang }) => {
		let finalLang = lang || "es";
		if (!AVAILABLE_LANGUAGES_ARRAY.includes(lang)) {
			finalLang = "es";
		}
		localStorage.setItem("language", finalLang);
	};

	const setLanguage = useCallback(({ lang }) => {
		if(isEngUrl&& lang !== "en"){
			const newPath = pathnname.replace("/en/", "/");
			history.replace(newPath, {__skipLocale: true});
		}else{
			updateStateLanguage({ lang });
			updateLocalStorageLanguage({ lang });
		}
	}, [pathnname, isEngUrl, history]);

	return {
		setLanguage,
	};
};
